import React from 'react';
import { PowerOutageSchedulLimitItem } from './PowerOutageSchedulLimitItem';
import { useTranslation } from 'react-i18next';

interface PowerOutageScheduleLimitProps {
  data: Array<PowerOutageScheduleLimitData>;
  testId?: string;
  className?: string;
  errorIndex?: number | null;
  onChange?: (
    index: number,
    key: keyof PowerOutageScheduleLimitData,
    value: string | boolean | number | null
  ) => void;
}

export const PowerOutageScheduleLimit: React.FC<
  PowerOutageScheduleLimitProps
> = ({ testId, className, data, errorIndex, onChange }) => {
  const { t } = useTranslation();
  return (
    <div
      data-testid={testId}
      className={`mt-4 grid w-[600px] grid-cols-3 gap-2 rounded-[5px] bg-light-2 p-[10px] [@media(max-height:1000px)]:mt-[10px] ${className}`}
    >
      {data.map((value) => {
        const limitIndex = value.index;

        return (
          <PowerOutageSchedulLimitItem
            isLock={value.isLock}
            isError={limitIndex === errorIndex}
            onChange={(
              key: keyof PowerOutageScheduleLimitData,
              value: string | boolean | number | null
            ) => onChange?.(limitIndex, key, value)}
            value={
              value.value === null
                ? ''
                : typeof value.value === 'number'
                  ? value.value.toString()
                  : value.value
            }
            key={`${testId}-item-${limitIndex.toString()}`}
            testId={`${testId}-item-${limitIndex.toString()}`}
            text={`${value.name}${t('overview.modal.limit.generator')}`}
          />
        );
      })}
    </div>
  );
};
